/* eslint-disable no-console */
import stringify from "fast-json-stable-stringify";
// TODO: FIX FRONT IS DEPENDENT ON API TYPES

import type {
  Channel,
  ServerMessage,
} from "../../../../service-diagnostics-core/src/websocket/Message";

type OnMessage<T extends Channel> = (message: ServerMessage<T>["payload"]) => void;
interface ChannelState<T extends Channel> {
  onMessages: OnMessage<T>[];
  payload: ServerMessage<T>["payload"] | undefined;
  once: boolean;
}

const channelStateMap = new Map<string, ChannelState<Channel>>();

export const getChannels = () =>
  Array.from(channelStateMap.keys()).map(channelPath => JSON.parse(channelPath) as Channel);

export const getPayload = <T extends Channel>(channel: T) => getState(channel)?.payload;
export const getState = <T extends Channel>(channel: T) => {
  const state = channelStateMap.get(stringify(channel));
  if (state === undefined)
    console.error("ws:state", `cannot getState for channel ${stringify(channel)}`, {
      channel,
      channelStateMap,
    });

  return state;
};
export const setPayload = <T extends Channel>(channel: T, payload: ServerMessage<T>["payload"]) => {
  const state = getState(channel);
  if (state === undefined) throw new Error(`cannot setPayload for channel ${stringify(channel)}`);
  state.payload = payload;
};

// register a new subscriber for a channel
export const addOnMessage = <T extends Channel>(
  channel: T,
  onMessage: OnMessage<T>,
  once: boolean, // do not trigger onMessage for more than one instance of useChannel with the same channel (the older one registered will trigger)
): boolean => {
  const channelPath = stringify(channel);
  const state = channelStateMap.get(channelPath);
  if (state === undefined) {
    channelStateMap.set(channelPath, {
      onMessages: [onMessage] as OnMessage<Channel>[],
      payload: undefined,
      once,
    });
    return true;
  } else {
    state.onMessages = Array.from(new Set([...state.onMessages, onMessage as OnMessage<Channel>]));
    if (once !== state.once) {
      throw new Error(
        `cannot change once flag for channel ${channelPath}, it is either true for all subscribers, or false for all subscribers`,
      );
    }
    return false;
  }
};

// removes a subscriber on a channel, returns true if it was the last subscriber
export const removeOnMessage = <T extends Channel>(
  channel: T,
  onMessage: OnMessage<T>,
): boolean => {
  const channelPath = stringify(channel);
  const state = channelStateMap.get(channelPath);
  if (state === undefined) {
    console.error(
      "ws:state",
      `cannot removeOnMessage for channel ${channelPath}, it does not exist`,
      {
        channel,
        channelStateMap,
      },
    );
    return false;
  }
  state.onMessages = state.onMessages.filter(onM => onM !== onMessage);
  if (state.onMessages.length === 0) {
    channelStateMap.delete(channelPath);
    return true;
  }

  return false;
};
